import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldEditor } from './FieldEditor.js';
import { StorageKey } from '../modules/ModuleFE_LocalStorage.js';
import { ComponentSync } from '../core/ComponentSync.js';
export class FieldEditorWithButtons extends ComponentSync {
    createStorageKey() {
        return new StorageKey(`editable-label-controller-${this.props.id}`);
    }
    deriveStateFromProps(nextProps) {
        return {
            storageKey: this.createStorageKey(),
            isEditing: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.id !== this.props.id) {
            this.setState({ storageKey: this.createStorageKey() });
        }
    }
    handleEdit = () => {
        // Save the state's value in case of cancellation.
        this.setState({ isEditing: true });
    };
    handleSave = () => {
        this.props.onAccept(this.state.storageKey.get() ?? '');
        this.handleCancel();
    };
    handleCancel = () => {
        this.state.storageKey.delete();
        this.setState({ isEditing: false });
    };
    render() {
        const { isEditing } = this.state;
        return (_jsxs("div", { className: `ll_h_c`, style: { justifyContent: 'space-between' }, children: [_jsx("div", { children: _jsx(FieldEditor, { id: this.props.id, type: this.props.type, isEditing: this.state.isEditing, inputProps: this.props.inputProps, labelProps: this.props.labelProps, onAccept: this.handleSave, onCancel: this.handleCancel, storageKey: this.state.storageKey, value: this.props.value }) }), isEditing ? this.renderControlButtons() : this.renderEditButton()] }));
    }
    renderEditButton = () => {
        return _jsx("button", { onClick: this.handleEdit, children: "Edit" });
    };
    renderControlButtons = () => {
        return _jsxs("div", { children: [_jsx("button", { onClick: this.handleSave, children: "Save" }), _jsx("button", { onClick: this.handleCancel, children: "Cancel" })] });
    };
}
//# sourceMappingURL=FieldEditorWithButtons.js.map